import TextField from "@mui/material/TextField";
import { KeyboardKey } from "_shared/_utilities/keyboard-keys";
import React from "react";
import { NumericFormat } from "react-number-format";

type FilterNumericProps = {
  filterName: string;
  label: string;
  /** The applied value; null when the filter is not set. */
  value: number | null;
  disabled?: boolean;
  onChange: (filterName: string, value: number | null) => void;
};

/**
 * A number filter, applied on Enter or when the field loses focus. It searched on every keystroke
 * while it hid behind a switch, so typing "2014" ran four searches for 2, 20, 201 and 2014; now
 * that it is always in view it holds a draft, as the text filters do.
 */
export default function FilterNumeric(props: Readonly<FilterNumericProps>) {
  const { filterName, label, value, disabled, onChange } = props;
  const [draft, setDraft] = React.useState<number | undefined>(value ?? undefined);

  function commit() {
    const next = draft ?? null;
    if (next !== value) onChange(filterName, next);
  }

  return (
    <NumericFormat
      customInput={TextField}
      name={filterName}
      label={label}
      placeholder={label}
      size="small"
      fullWidth
      disabled={disabled}
      allowNegative={false}
      value={draft ?? ""}
      onValueChange={(values) => setDraft(values.floatValue)}
      onBlur={commit}
      onKeyDown={(event: React.KeyboardEvent) => {
        if (event.key === KeyboardKey.Enter) {
          event.preventDefault();
          commit();
        }
        if (event.key === KeyboardKey.Escape) {
          event.preventDefault();
          setDraft(value ?? undefined);
        }
      }}
    />
  );
}
